<!-- BEGIN: Aside Menu -->
<div class="kt-aside-menu-wrapper  kt-grid__item kt-grid__item--fluid" id="kt_aside_menu_wrapper">
    <div #asideMenu ktMenu [options]="menuOptions" style="overflow:auto!important" [ngStyle]="{'max-height': '85vh', 'position': 'relative'}" id="kt_aside_menu" class="kt-aside-menu"
         [attr.data-ktmenu-vertical]="1" [attr.data-ktmenu-scroll]="ui.getIsMenuScrollable() ? 1 : 0" [attr.data-ktmenu-dropdown]="ui.isSubmenuToggleDropdown() ? 1 : 0"
         (mouseenter)="mouseEnter($event)" (mouseleave)="mouseLeave($event)"
         [class]="ui.getLeftAsideClass()">
        <ul class="kt-menu__nav" class="kt-menu__nav" style="padding-top: 0px;padding-bottom:0px">
            <ng-container [ngTemplateOutlet]="menuListTemplate"></ng-container>
        </ul>
    </div>
</div>
<!-- END: Aside Menu -->

<!-- </div> -->
<ng-template #menuListTemplate>
    <ng-container *ngFor="let child of menu.items">
        <ng-container *ngIf="showMenuItem(child)" [ngTemplateOutlet]="mMenuItem" [ngTemplateOutletContext]="{ item: child, parentItem: item }"></ng-container>
    </ng-container>
</ng-template>

<ng-template #mMenuItem let-item="item" let-parentItem="parentItem">
    <li *ngIf="showMenuItem(item)"
        class="{{ui.getSideBarMenuItemClass(item, isMenuItemIsActive(item))}}"
        aria-haspopup="true"
        >

        <!-- if menu item hasn't submenu -->
        <a (click)="openSidebar(item)" *ngIf="!item.items.length && !item.external" [queryParams]="item.parameters" [routerLink]="item.route" class="kt-menu__link">
            <ng-container [ngTemplateOutlet]="mMenuItemText" [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"></ng-container>
        </a>
        <a (click)="openSidebar(item)" *ngIf="!item.items.length && item.external" [attr.href]="item.route" target="_blank" class="kt-menu__link kt-menu__toggle">
            <ng-container [ngTemplateOutlet]="mMenuItemText" [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"></ng-container>
        </a>
        <!-- if menu item has submenu child  -->
        <a (click)="openSidebar(item)" href="javascript:;"  *ngIf="item.items.length" class="kt-menu__link kt-menu__toggle">
            <ng-container [ngTemplateOutlet]="mMenuItemText" [ngTemplateOutletContext]="{ item: item, parentItem: parentItem }"></ng-container>
        </a>

        <!-- if menu item has submenu child then recursively call new menu item component -->
        <div *ngIf="item.items.length" class="kt-menu__submenu">
            <span class="kt-menu__arrow"></span>
            <ul class="kt-menu__subnav">
                <ng-container *ngFor="let child of item.items">
                    <ng-container [ngTemplateOutlet]="mMenuItem" [ngTemplateOutletContext]="{ item: child, parentItem: item }"></ng-container>
                </ng-container>
            </ul>
        </div>
    </li>
</ng-template>

<ng-template #mMenuItemText let-item="item" let-parentItem="parentItem">
    <span class="kt-menu__item-here"></span>
    
    <!-- if menu item has icon -->
    <span class="kt-menu__link-icon" *ngIf="item.icon">
        <i class="kt-menu__link-icon" [ngClass]="item.icon"></i>
        <!-- <img *ngIf="!isMenuItemIsActive(item) && currentActiveParentItem !== item" [src]="item.icon" class="sidebar-icon"> -->
        <!-- <img *ngIf="isMenuItemIsActive(item) || currentActiveParentItem === item" [src]="item.icon.replace('.svg', '2.svg')" class="sidebar-icon2"> -->
    </span>

    <ng-container *ngIf="!item.badge; else mMenuLinkBadge">
        <!-- menu item title text -->
        <span class="kt-menu__link-text" >
            {{item.name | localize}}
        </span>
        <!-- <div class="tooltip-menu">
            {{item.name}}
        </div> -->
    </ng-container>

    <ng-template #mMenuLinkBadge>
        <!-- menu item with badge -->
        <span class="kt-menu__link-title">
            <span class="kt-menu__link-wrap">
                <span class="kt-menu__link-text">
                    {{item.name | localize}}
                </span>
                <span class="kt-menu__link-badge">
                    <span class="kt-badge" [ngClass]="item.badge.type">{{item.badge.value}}</span>
                </span>
            </span>
        </span>
    </ng-template>

    <!-- if menu item has submenu child then put arrow icon -->
    <!-- <i *ngIf="item.items.length" class="kt-menu__ver-arrow la la-angle-right"></i> -->
    <i *ngIf="item.items.length" class="kt-menu__ver-arrow hgi hgi-stroke hgi-arrow-right-01"></i>
</ng-template>


<!-- Profile Section  -->
 
<div class="side-profile-section">
    <div class="row" style="padding-bottom:6px">
        <div class="main-dropdown dropdown">
            <div class="sidebar-profile" type="button" id="dropdownProfileButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <div class="up-arrow">
                    <img src="../../../../assets/common/images/arrow-down-icon.svg" alt="">
                </div>
                <div class="profile-sidebar">
                    <div class="profile-side image">
                        <ng-container *ngIf="userImage != ''" >
                            <img style="object-fit: cover !important;"                            
                            [src]="userImage"
                            class="Usrimg" />
                        </ng-container>
                        <ng-container *ngIf="userImage == ''" >
                            <img src="../../../../assets/common/images/user-03.svg" alt="">
                        </ng-container>                        
                    </div>
                    <div class="profile-side-name">
                        <div class="profile-head">Hi,{{name}}</div>
                        <div class="profile-subhead">{{designation}}</div>
                    </div>
                </div>
                <div class="sidebar-icon-arrow">
                    <img src="../../../../assets/common/images/arrow-down-icon.svg" alt="">
                </div>
            </div>
            <div class="dropdown-menu shadow-md" aria-labelledby="dropdownProfileButton">
                <a class="dropdown-item" (click)="changePassword()" href="javascript:void(0)">
                    <!-- <img src="../../../assets/common/images/user-03.svg" alt="" > -->
                    <i class="hgi hgi-stroke hgi-lock-password"></i>
                     Change Password</a>
                <a class="dropdown-item" (click)="MyProfilePicture()" href="javascript:void(0)">
                    <!-- <img src="../../../assets/common/images/user-profile.svg" style="width:18px" alt=""> -->
                    <i class="hgi hgi-stroke hgi-user-square"></i>
                     My Profile</a>
                <a *ngIf="isImpersonatedLogin" class="dropdown-item" (click)="backToMyAccount()" href="javascript:void(0)">
                    <!-- <img src="../../../assets/common/images/user-03.svg" alt=""> -->
                    <i class="hgi hgi-stroke hgi-link-backward"></i>
                    Back To My Account</a>
                <a class="dropdown-item" (click)="logout()" href="javascript:void(0)">
                    <!-- <img src="../../../assets/common/images/delete-drop.svg" alt=""> -->
                    <i class="hgi hgi-stroke hgi-logout-02"></i>
                     Logout</a>
              </div>
        </div>
    </div>
    <div class="row" style="border-top:1px solid #d3d3d3;padding-top:5px">
        <img src="../../../../assets/common/images/Perfettohr-logo-green.png" class="perfetto-logo" alt="">
    </div>
</div>

<!-- END: Left Aside -->
